const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const authService = {
  // Login
  async login(usuario, senha) {
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ usuario, senha })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.mensagem || 'Erro ao fazer login');
    }

    return data.dados;
  },

  // Verificar primeiro acesso
  async verificarPrimeiroAcesso(accessToken) {
    const response = await fetch(`${API_URL}/api/auth/verificar-primeiro-acesso`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.mensagem || 'Erro ao verificar primeiro acesso');
    }

    return data.dados;
  },

  // Trocar senha no primeiro acesso
  async trocarSenhaPrimeiroAcesso(accessToken, senhaAtual, novaSenha) {
    const response = await fetch(`${API_URL}/api/auth/trocar-senha-primeiro-acesso`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        senha_atual: senhaAtual,
        nova_senha: novaSenha
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.mensagem || 'Erro ao trocar senha');
    }

    return data;
  },

  // Renovar token
  async refreshToken(refreshTokenValue) {
    const response = await fetch(`${API_URL}/api/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        refresh_token: refreshTokenValue
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.mensagem || 'Erro ao renovar token');
    }

    return data.dados;
  },

  // Logout
  async logout(accessToken) {
    const response = await fetch(`${API_URL}/api/auth/logout`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.mensagem || 'Erro ao fazer logout');
    }

    return data;
  }
};




